import { createContext, useContext, useMemo, useState } from "react";
import { generateUniqueID } from "../Service/service";
import AlertUI from "../Reuse/UI/AlertUI";

const AlertsContext = createContext();

export const AlertsProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  // call this function when you want to authenticate the user
  const showAlerts = async (title, message = null, type = "success") => {
    const id = generateUniqueID();

    const data = {
      title: title,
      message: message,
      id,
      type,
      duration: 1000 * 6,
    };
    setAlerts((preState) => [...preState, data]);
  };
  const hideAlerts = async (id) => {
    setAlerts((preState) => preState.filter((el) => el.id !== id));
  };

  const value = useMemo(
    () => ({
      showAlerts,
    }),
    []
  );
  return (
    <AlertsContext.Provider value={value}>
      <AlertUI alerts={alerts} hideAlerts={hideAlerts} />
      {children}
    </AlertsContext.Provider>
  );
};

export const useAlerts = () => {
  return useContext(AlertsContext);
};